import { tns } from 'tiny-slider/src/tiny-slider.module'

function imageCarousel() {
  function generatePagination(el, current, total) {
    const paginationEl = el
    paginationEl.innerHTML = `${current}|${total}`
  }

  function pagination(info, el) {
    // Not showing cloned item count.
    // Because of the looping behaviour there are cloned slides
    // and the index will count them for the last slide.
    if (info.index <= info.slideCount) {
      generatePagination(el, info.index, info.slideCount)
    }
  }

  [].forEach.call([...document.querySelectorAll('[data-carousel]')], (el) => {
    const carouselNav = el.nextElementSibling
    const nextButton = carouselNav.querySelector('[data-carousel-next]')
    const prevButton = carouselNav.querySelector('[data-carousel-prev]')
    const paginationEl = carouselNav.querySelector('[data-carousel-pagination]')

    const carousel = tns({
      container: el,
      items: 1,
      nav: false,
      mouseDrag: true,
      arrowKeys: true,
      autoHeight: true,
      nextButton,
      prevButton,
      onInit(info) {
        generatePagination(paginationEl, info.index, info.slideCount)
      },
    })

    carousel.events.on('indexChanged', (info) => {
      pagination(info, paginationEl)
    })
  })
}

export default imageCarousel 